const Expected = "expected";
const CreatedNew = "created_new";
const QuotedNew = "quoted_new";
const Success = "success";
const Failure = "failure";

function all(): string[] {
  return [Expected, CreatedNew, QuotedNew, Success, Failure];
}

export default {
  Expected,
  CreatedNew,
  QuotedNew,
  Success,
  Failure,
  all
};
